export default __webpack_public_path__ + "static/media/logo123456.6eccccd0.png";